module.exports = __webpack_public_path__ + "img/Number.6b6402de.svg";